module.exports = __webpack_public_path__ + "static/media/intro.af97639c.mp3";